@if (surveyEditorService.surveyEditor$().activeQuestion; as activeQuestion) {
  <form [formGroup]="activeQuestion">
    <div class="question-form__array">
      <div class="header">
        <span class="label">Options</span>
        <div class="question-form__rating-types">
          <button
            mat-stroked-button
            class="rating-type__btn"
            [class.active]="activeQuestion.get('ratingType').value === ratingType.numeric"
            (click)="onChangeRatingType(ratingType.numeric)"
          >
            <span>Numerical</span>
            <fa-icon [icon]="faCheckCircle"></fa-icon>
          </button>
          <button
            mat-stroked-button
            class="rating-type__btn"
            [class.active]="activeQuestion.get('ratingType').value === ratingType.descriptive"
            (click)="onChangeRatingType(ratingType.descriptive)"
          >
            <span>Descriptive</span>
            <fa-icon [icon]="faCheckCircle"></fa-icon>
          </button>
          @if (!isRankSort()) {
            <button
              mat-stroked-button
              class="rating-type__btn"
              [class.active]="activeQuestion.get('ratingType').value === ratingType.stars"
              (click)="onChangeRatingType(ratingType.stars)"
            >
              <span>Stars</span>
              <fa-icon [icon]="faCheckCircle"></fa-icon>
            </button>
          }
        </div>
      </div>

      @if (activeQuestion.get('ratingType').value === ratingType.numeric) {
        <div class="question-form__rating-scale">
          <div class="editor-question-form__input rating-scale__input-container">
            <span class="label">Rating Scale</span>
            <mat-form-field appearance="outline">
              <button
                matPrefix
                mat-icon-button
                title="decrease scale"
                class="decrease"
                [disabled]="activeQuestion.get('ratingScale').value <= minRatingScale$()"
                (click)="onDecreaseScale()"
              >
                <fa-icon [icon]="faMinus"></fa-icon>
              </button>
              <input
                matInput
                type="number"
                step="1"
                formControlName="ratingScale"
                class="rating-scale__input"
                editorAutoFocus
                block="nearest"
                autocomplete="off"
                [min]="minRatingScale$()"
                (blur)="onRatingInputChange($event)"
              />
              <button
                matSuffix
                mat-icon-button
                title="increase scale"
                class="increase"
                [disabled]="!!maxValue() && activeQuestion.get('ratingScale').value >= maxValue()"
                (click)="onIncreaseScale()"
              >
                <fa-icon [icon]="faPlus"></fa-icon>
              </button>
            </mat-form-field>
          </div>
          @if (!isRankSort()) {
            <div class="editor-question-form__input">
              <span class="label">Start</span>
              <mat-form-field appearance="outline">
                <input matInput formControlName="minValueText" editorAutoFocus block="nearest" autocomplete="off" />
              </mat-form-field>
            </div>
            <div class="editor-question-form__input">
              <span class="label">End</span>
              <mat-form-field appearance="outline">
                <input matInput formControlName="maxValueText" editorAutoFocus block="nearest" autocomplete="off" />
              </mat-form-field>
            </div>
          }
        </div>
      }

      @if (activeQuestion.get('ratingType').value === ratingType.descriptive) {
        <div [formArrayName]="isRankSort() ? 'ranks' : 'options'" class="question-form_array_list">
          @for (optionCtrl of (activeQuestion.get(isRankSort() ? 'ranks' : 'options') | toFormArray).controls; track optionCtrl) {
            <div>
              <div [formGroupName]="$index" class="question-form__array__input">
                <empathy-text-editor
                  [id]="optionCtrl.value.id"
                  [control]="optionCtrl.get('text')"
                  [autofocus]="justAddedOptionId === optionCtrl.value.id"
                  [stopDefaultTab]="true"
                  [splitOnPaste]="true"
                  (tab)="onAddOption($last, $index)"
                  (paste)="onPaste($event, $index)"
                >
                  <div slot="prefix" class="eiq-id-badge">
                    <span>{{ optionCtrl.value.id }}</span>
                  </div>
                  <div slot="suffix" class="actions">
                    @if (options.controls.length > 2) {
                      <button mat-icon-button color="warn" title="Delete Option" (click)="onRemoveAt($index, optionCtrl.get('id').value)">
                        <fa-icon [icon]="faTrashCan"></fa-icon>
                      </button>
                    }
                  </div>
                </empathy-text-editor>
              </div>
            </div>
          }
        </div>

        @if (!!maxValue() && options.length < maxValue()) {
          <div class="footer">
            <button mat-button color="primary" [disabled]="!addOptionAllowed" (click)="onAddOption(true)">
              <fa-icon [icon]="faPlus"></fa-icon>
              New Option
            </button>
          </div>
        }
      }

      @if (activeQuestion.get('ratingType').value === ratingType.stars) {
        <div class="question-form__rating-scale">
          <div class="editor-question-form__input rating-scale__input-container">
            <span class="label">Rating Scale</span>
            <mat-form-field appearance="outline">
              <button
                matPrefix
                mat-icon-button
                title="decrease scale"
                class="decrease"
                [disabled]="activeQuestion.get('ratingScale').value === 2"
                (click)="onDecreaseScale()"
              >
                <fa-icon [icon]="faMinus"></fa-icon>
              </button>
              <input
                matInput
                type="number"
                min="2"
                step="1"
                max="10"
                formControlName="ratingScale"
                class="rating-scale__input"
                editorAutoFocus
                block="nearest"
                autocomplete="off"
                (blur)="onRatingInputChange($event)"
              />
              <button
                matSuffix
                mat-icon-button
                title="increase scale"
                class="increase"
                (click)="onIncreaseScale()"
                [disabled]="activeQuestion.get('ratingScale').value >= 10"
              >
                <fa-icon [icon]="faPlus"></fa-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="editor-question-form__input">
            <span class="label">Start</span>
            <mat-form-field appearance="outline">
              <input matInput formControlName="minValueText" editorAutoFocus block="nearest" autocomplete="off" />
            </mat-form-field>
          </div>
          <div class="editor-question-form__input">
            <span class="label">End</span>
            <mat-form-field appearance="outline">
              <input matInput formControlName="maxValueText" editorAutoFocus block="nearest" autocomplete="off" />
            </mat-form-field>
          </div>
        </div>
      }
    </div>
  </form>
}
